import * as UpdateInvestorTypeTypes from 'src/actions/investor-type/update/Types';
import { UpdateInvestorTypeAction } from
    'src/actions/investor-type/update/UpdateInvestorType.actions';

export interface UpdateInvestorTypeState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: UpdateInvestorTypeState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function UpdateInvestorTypeReducer(state: UpdateInvestorTypeState = initialState,
                                          action: UpdateInvestorTypeAction):
  UpdateInvestorTypeState {
  switch (action.type) {
    case UpdateInvestorTypeTypes.UPDATE_INVESTOR_TYPE_ATTEMPT:
      return {...state, loading: true, error: false};
    case UpdateInvestorTypeTypes.UPDATE_INVESTOR_TYPE_SUCCESS:
      return {...state, loading: false, error: false};
    case UpdateInvestorTypeTypes.UPDATE_INVESTOR_TYPE_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/investor-type/UpdateInvestorTypeReducer.tsx